import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { lang, remCss, scssVariables, useLanguage } from 'src/helpers';
import SVGIcon from 'src/components/svg';
import { RotatingLines } from 'react-loader-spinner';
import { convertMobileStyle } from 'src/helpers';

export const MCButton = ({
  iconname,
  label,
  type = 'button',
  onClick,
  flex,
  small,
  large,
  medium,
  tiny,
  largeMedium,
  light,
  outline,
  dark,
  transparent,
  base,
  radius,
  rounded,
  circle,
  secondary,
  tertiary,
  quaternary,
  senary,
  septenary,
  primary,
  blacklight,
  shadow,
  text,
  hover,
  className = '',
  style = {},
  children,
  width,
  fill,
  padding,
  loading,
  tabIndex,
  hoverOpacity = false,
  iconFill: propIconFill,
  ...props
}) => {
  style = convertMobileStyle(style);
  useLanguage();
  const [downloading, setDownloading] = useState(false);
  if (downloading) loading = true;
  // default styles: medium, primary
  let attributes = {
    primary,
    secondary,
    tertiary,
    quaternary,
    senary,
    septenary,
    text,
    blacklight
  };
  let color = Object.keys(attributes).find((k) => !!attributes[k]) || 'primary';
  let iconFill = propIconFill || scssVariables['colors-mc-' + color];

  attributes = {
    small,
    medium,
    large,
    largeMedium,
    tiny
  };
  let size = Object.keys(attributes).find((k) => !!attributes[k]) || 'medium';

  attributes = {
    base,
    light,
    outline,
    dark,
    transparent,
    shadow
  };
  let format = Object.keys(attributes).filter((k) => !!attributes[k]) || [];

  attributes = {
    radius,
    rounded,
    circle
  };
  let form = Object.keys(attributes).find((k) => !!attributes[k]) || '';

  let classNames = [...className.split(' '), 'mc-button', size, color, format.join(' '), form];

  if (flex) classNames.push('mc-grow');
  if (hoverOpacity) classNames.push('mc-hover-opacity');

  if (hover === true || (hover !== false && (onClick || type !== 'button')))
    classNames.push('hover');

  if (!label && !children) {
    classNames.push('icon');
    if (!width) width = largeMedium || large ? 60 : small ? 30 : 44;
    if (!padding) padding = largeMedium || large ? 8 : small ? 3 : 5;
    const child = (
      <SVGIcon
        iconname={iconname}
        light={light}
        outline={outline}
        dark={dark}
        radius={radius}
        width={width}
        circle={circle}
        padding={padding}
        fill={fill || iconFill}
        {...props}
      />
    );
    if (type === 'link') {
      return (
        <Link
          type={type}
          onClick={onClick}
          className={classNames.join(' ')}
          style={{
            minWidth: remCss(width),
            maxWidth: remCss(width),
            height: remCss(width),
            ...style
          }}
          tabIndex={tabIndex}
          {...props}
        >
          {child}
        </Link>
      );
    }
    return (
      <button
        type={type}
        className={classNames.join(' ')}
        style={{
          minWidth: remCss(width),
          maxWidth: remCss(width),
          height: remCss(width),
          ...style
        }}
        onClick={onClick}
        tabIndex={tabIndex}
        {...props}
      >
        {child}
      </button>
    );
  }

  let iconWidth = 24;
  if (small) iconWidth = 20;
  if (large || largeMedium) iconWidth = 30;
  if (dark) iconFill = '#fff';

  let loadingWidth = large ? 30 : small ? 20 : tiny ? 15 : 24;

  if (!children)
    children = (
      <>
        {iconname && <SVGIcon iconname={iconname} fill={iconFill} width={width || iconWidth} />}
        {loading && (
          <RotatingLines
            strokeColor={iconFill}
            height={remCss(loadingWidth)}
            width={remCss(loadingWidth)}
            animationDuration={1}
          />
        )}
        <span className={'mc-text-truncate'}>{lang.t(label)}</span>
      </>
    );

  if (type === 'link') {
    classNames.push('mc-pointer');
    return (
      <Link
        type={type}
        onClick={onClick}
        className={classNames.join(' ')}
        style={style}
        tabIndex={tabIndex}
        {...props}
      >
        {children}
      </Link>
    );
  }
  if (type === 'download') {
    classNames.push('mc-pointer');
    const handleDownload = (e) => {
      e && e.preventDefault();
      if (downloading) return;
      setDownloading(true);
      fetch(props.to)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.download = props.fileName || props.to.split('/').pop().split(/[?#]/)[0]; // file name
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          setDownloading(false);
        })
        .catch((error) => {
          console.error('Error fetching the file:', error);
          setDownloading(false);
        });
    };
    return (
      <Link
        type={type}
        onClick={handleDownload}
        className={classNames.join(' ')}
        style={style}
        tabIndex={tabIndex}
        {...props}
        disabled={downloading}
      >
        {children}
      </Link>
    );
  }

  if (!onClick && type !== 'submit')
    return (
      <div className={classNames.join(' ')} style={{ ...style, cursor: 'revert' }} {...props}>
        {children}
      </div>
    );

  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames.join(' ')}
      style={style}
      tabIndex={tabIndex}
      {...props}
    >
      {children}
    </button>
  );
};
